import { getAccessToken, getOktaAccessToken } from './utils/cookies';

const normalizeHeaders = (headers: HeadersInit | undefined, oktaToken?: string, accessToken?: string): HeadersInit => {
    const headersObj = new Headers(headers);

    if (oktaToken && !accessToken) {
        headersObj.set('Authorization', `Bearer ${oktaToken}`);
    }

    return Object.fromEntries(headersObj.entries());
};

export const injectOktaToken = (init?: RequestInit): RequestInit => {
    const accessToken = getAccessToken();
    const oktaToken = getOktaAccessToken();

    return {
        ...init,
        headers: normalizeHeaders(init?.headers, oktaToken, accessToken),
    };
};

export const applyOktaTokenInjection = async (init?: RequestInit): Promise<RequestInit> => {
    if (typeof window !== 'undefined') {
        return injectOktaToken(init);
    }
    return init ?? {};
};
